<template>
    <div class="mb-4 rounded-lg p-4">
        <header class="flex cursor-pointer items-center justify-between" @click.prevent="toggleOpen()">
            <div>
                <h4 :class="`whitespace-nowrap ${titleSize} font-bold leading-6 text-gray-700`">
                    {{ title }}
                </h4>
            </div>
            <div class="flex items-center gap-4">
                <h4 v-if="subtitle" class="text-base font-bold leading-6 text-gray-700">
                    {{ subtitle }}
                </h4>
                <button :aria-expanded="open">
                    <ChevronDownIcon :class="`text-color-primary w-5 ${open ? 'rotate-180' : ''}`" />
                </button>
            </div>
        </header>
        <div v-show="open">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { ChevronDownIcon } from '@heroicons/vue/outline'

const props = withDefaults(
    defineProps<{
        title: string
        titleSize?: string
        subtitle?: string | null
        open?: boolean
    }>(),
    {
        titleSize: 'text-base',
        subtitle: null,
    }
)

const open = ref(props.open === true)

function toggleOpen(): void {
    if (open.value === true) {
        open.value = false
    } else {
        open.value = true
    }
}
</script>

<style scoped></style>
